import { HTTPClient } from "@/common/HTTPClient";

export interface AuthLoginRequestParams {
  email: string;
  password: string;
}

// export interface AuthSetPasswordRequestParams {
//   password: string;
// }

export class AuthClient {
  constructor(private httpClient: HTTPClient) {}

  public async login(params: AuthLoginRequestParams): Promise<void> {
    await this.httpClient.setupToken(params);
  }

  public async logout(): Promise<any> {
    this.httpClient.clearToken();
  }

  //   public async setPassword(params: AuthSetPasswordRequestParams): Promise<any> {
  //     await this.httpClient.request({
  //       url: "/auth/setpassword",
  //       method: "POST",
  //       data: params,
  //     });
  //   }
}
